import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/toa-mega-paint`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const toaMegapaintApi = {
  getCampaign: (data) => {
    return instance().get('/campaign', { params: { page_id: data.pageid } })
  },
  postCamapign: (body) => {
    return instance().post('/campaign', body)
  },
  putCamapign: (campaignId, body) => {
    return instance().put(`/campaign/${campaignId}`, body)
  },
  deleteCamapign: (campaignId, data) => {
    return instance().delete(`/campaign/${campaignId}`, { data })
  },
  postCampaignStatus: (body) => {
    return instance().post(`/campaign/${body.campaignId}/enable`, body)
  },
  getMegaPaintBranch: (params) => {
    return instance().get(`/branch`, { params })
  },
  postMegaPaintBranch: (body) => {
    return instance().post(`/branch`, body)
  },
  putMegaPaintBranch: (body) => {
    return instance().put(`/branch`, body)
  },
  deleteMegaPaintBranch: (data) => {
    return instance().delete(`/branch`, { data })
  },
  getEcouuponCampaignProduct: (params) => {
    return instance().get(`/ecouponcampaign-product`, { params })
  },
  postEcouuponCampaignProduct: (body) => {
    return instance().post(`/ecouponcampaign-product`, body)
  },
  putEcouuponCampaignProduct: (body) => {
    return instance().put(`/ecouponcampaign-product`, body)
  },
  daleteEcouuponCampaignProduct: (data) => {
    return instance().delete(`/ecouponcampaign-product`, { data })
  },
  getReceipt: (params) => {
    return instance().get(`/receipt`, { params })
  },
  putReceipt: (id, body) => {
    return instance().put(`/receipt/${id}`, body)
  },
  checkDupReceipt: (body) => {
    return instance().post(`/cms/campaign/receipt/duplicate`, body)
  },
  getReward: (params) => {
    return instance().get(`/ecouponcampaignrewards`, { params })
  },
  getExportReward: (params) => {
    return instance().get(`/exportrewards`, { params })
  },
  postApproveReward: (body) => {
    return instance().post(`/ecouponcampaignrewards/approved-rewards`, body)
  },
  postApproveAllReward: (body) => {
    return instance().post(`/ecouponcampaignrewards/approved-all-rewards`, body)
  },
  postSendingTrackingForReward: (body) => {
    return instance().post(`/ecouponcampaignrewards/shipping/send-tracking`, body)
  },
  putUpdateShippingRewardStatus: (body) => {
    return instance().put(`/ecouponcampaignrewards/shipping/update-status`, body)
  },
  putUpdateShippingReward: (body) => {
    return instance().put(`/ecouponcampaignrewards/shipping/update-info`, body)
  },
  getShippingReward: (params) => {
    return instance().get(`/ecouponcampaignrewards/shipping`, { params })
  },
  getStore: (params) => {
    return instance().get(`/cms/campaign/store`, { params })
  },
  postStore: (body) => {
    return instance().post(`/cms/campaign/store`, body)
  },
  putStore: (body) => {
    return instance().put(`/cms/campaign/store`, body)
  },
  deleteStore: (data) => {
    return instance().delete(`/cms/campaign/store`, { data })
  },
  importStore: (body) => {
    return instance().post(`/cms/campaign/store/import`, body)
  },
  getProduct: (params) => {
    return instance().get(`/cms/campaign/product`, { params })
  },
  postProduct: (body) => {
    return instance().post(`/cms/campaign/product`, body)
  },
  putProduct: (body) => {
    return instance().put(`/cms/campaign/product`, body)
  },
  deleteProduct: (data) => {
    return instance().delete(`/cms/campaign/product`, { data })
  },
  importProduct: (body) => {
    return instance().post(`/cms/campaign/product/import`, body)
  },
  getRewardCategory: (params) => {
    return instance().get(`/cms/campaign/reward/category`, { params })
  },
  postRewardCategory: (body) => {
    return instance().post(`/cms/campaign/reward/category`, body)
  },
  putRewardCategory: (body) => {
    return instance().put(`/cms/campaign/reward/category`, body)
  },
  deleteRewardCategory: (data) => {
    return instance().delete(`/cms/campaign/reward/category`, { data })
  },
  getMember: (params) => {
    return instance().get(`/cms/member`, { params })
  },
  putMember: (body) => {
    return instance().put(`/cms/member/phone`, body)
  },
  getMemberReceipt: (params) => {
    return instance().get(`/cms/member/receipt`, { params })
  },
  sendEcoupon: (body) => {
    return instance().post(`/cms/order/send-ecoupon`, body)
  },
  getUsedCoupon: (params) => {
    return instance().get(`/cms/ecoupon-dashboard/used`, { params })
  },
  getCouponPoolSetting: (params) => {
    return instance().get(`/cms/e-coupon-pool-setting`, { params })
  },
  postCouponPoolSetting: (body) => {
    return instance().post(`/cms/e-coupon-pool-setting`, body)
  },
  putCouponPoolSetting: (id, body) => {
    return instance().put(`/cms/e-coupon-pool-setting/${id}`, body)
  },
  deleteCouponPoolSetting: (id, page_id) => {
    return instance().delete(`/cms/e-coupon-pool-setting/${id}`, {
      params: { page_id: page_id }
    })
  },
  getReceiveEcoupon: (params) => {
    return instance().get(`/cms/receive-e-coupon`, {
      params
    })
  }
}
export default toaMegapaintApi



// WEBPACK FOOTER //
// ./src/api/toa-mega-paint.js